import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import ReactDOM from "react-dom";
import Select from "react-select";
import { masterDataService } from "../../services/masterData.service";
import "react-datepicker/dist/react-datepicker.css";

const Section1 = ({
  dateRange,
  setDateRange,
  handleSearch,
  selectedOption,
  setSelectedOption,
}: {
  dateRange: [Date | null, Date | null];
  setDateRange: React.Dispatch<
    React.SetStateAction<[Date | null, Date | null]>
  >;
  handleSearch: () => void;
  selectedOption: { value: string; label: string } | null;
  setSelectedOption: React.Dispatch<
    React.SetStateAction<{ value: string; label: string } | null>
  >;
}) => {
  const [startDate, endDate] = dateRange;

  const [options, setOptions] = useState<{ value: string; label: string }[]>([
    { value: "", label: "NASIONAL" },
  ]);

  useEffect(() => {
    const fetchBranches = async () => {
      try {
        const branches = await masterDataService.getBranches();
        const branchOptions = branches.map((branch: any) => ({
          value: branch.BranchId,
          label: branch.BranchName,
        }));
        setOptions([{ value: "", label: "NASIONAL" }, ...branchOptions]);
      } catch (error) {
        console.error("Failed to load branches", error);
      }
    };

    fetchBranches();
  }, []);

  return (
    <div className="row">
      <div className="col-xl-12">
        <div className="page-title-box" style={{ backgroundColor: "#d3d3db" }}>
          <h5 className="page-title float-left">
            <table>
              <tbody>
                <tr>
                  <td style={{ padding: "2px 10px", paddingRight: "200px" }}>
                    <h5>DASHBOARD</h5>
                  </td>
                  <td style={{ padding: "2px 5px", minWidth: "200px" }}>
                    <Select
                      options={options}
                      value={selectedOption}
                      onChange={(option) => setSelectedOption(option)}
                      className="basic-single"
                      classNamePrefix="select"
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: "33px",
                          height: "33px",
                          fontSize: "12px",
                          boxShadow: "none",
                        }),

                        container: (provided) => ({
                          ...provided,
                          width: "100%",
                        }),
                        singleValue: (provided) => ({
                          ...provided,
                          marginLeft: "4px",
                          marginRight: "4px",
                          marginTop: "-3px",
                          padding: "0",
                        }),
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                    />
                  </td>

                  <td style={{ padding: "2px 5px" }}>
                    <DatePicker
                      selectsRange
                      startDate={startDate}
                      endDate={endDate}
                      onChange={(update) => setDateRange(update)}
                      isClearable
                      placeholderText="Select date range"
                      className="form-control"
                      dateFormat="dd/MM/yyyy"
                      popperPlacement="bottom-start"
                      popperContainer={({ children }) =>
                        ReactDOM.createPortal(children, document.body)
                      }
                    />
                  </td>
                  <td style={{ padding: "2px 10px", paddingLeft: "30px" }}>
                    <button
                      className="btn btn-primary ml-2"
                      onClick={handleSearch}
                    >
                      <i className="fa fa-search"></i> Search
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </h5>
          <div className="clearfix"></div>
        </div>
      </div>
    </div>
  );
};

export default Section1;
